<template>
    <div>
        <buttonlist ref="SetBtn" @help="help"></buttonlist>
        <div style="width:100%">
            <el-card class="box-card">
                <div style="display: flex">
                    <el-button @click="downFile" type="success" plain size="mini"
                    >{{$t('getapi[2762]')}}<i class="el-icon-download el-icon--right"></i>
                    </el-button>
                    <el-upload
                            class="upload-demo"
                            ref="upload"
                            :action="uploadurl"
                            :on-preview="handlePreview"
                            :on-remove="handleRemove"
                            :on-change="handleChange"
                            :on-success="handleSuccess"
                            :on-error="handleError"
                            :file-list="fileList"
                            :limit="1"
                            style="margin-left: 8px;width:150px"
                    >
                        <el-button type="primary" plain size="mini"
                        >{{$t('getapi[7478]')}}<i class="el-icon-upload el-icon--right"></i>
                        </el-button>
                    </el-upload>
                    <el-button type="primary" size="mini" @click="removeT"
                    >{{$t('getapi[7423]')}}
                    </el-button
                    >
                    <el-button type="primary" size="mini" @click="clearT"
                    >{{$t('getapi[7424]')}}
                    </el-button
                    >
                    <el-button
                            type="primary"
                            size="mini"
                            @click="doVerify"
                            :disabled="!btn.doVerify"
                    >{{$t('getapi[7622]')}}
                    </el-button
                    >
                    <el-button
                            type="primary"
                            size="mini"
                            @click="doCloseWIP"
                            :disabled="!btn.canDoCloseWIP"
                    >{{$t('getapi[7623]')}}
                    </el-button
                    >
                    <el-button
                            type="primary"
                            size="mini"
                            @click="exps"
                            :disabled="!btn.canDoCloseWIP && !btn.doVerify"
                    >{{$t('getapi[7624]')}}
                    </el-button
                    >
                </div>
            </el-card>
            <el-divider content-position="left">{{$t('getapi[7233]')}}</el-divider>
            <table>
                <tr>
                    <td style="width:60px">{{ $t("getapi[1974]") }}</td>
                    <td style="width:150px;">
                        <el-select
                                filterable
                                v-model="dataDetail.cboyear"
                                size="mini"
                                style="margin-righ:20px"
                        >
                            <el-option
                                    v-for="item in yearList"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value"
                            ></el-option>
                        </el-select>
                    </td>
                    <td style="width:60px">{{$t('getapi[7572]')}}</td>
                    <td style="width:150px;">
                        <el-input
                                v-model="dataDetail.txtSettleStatus"
                                type="text"
                                size="mini"
                                :disabled="true"
                        ></el-input>
                    </td>
                    <td style="width:60px">{{$t('getapi[7625]')}}</td>
                    <td style="width:150px;">
                        <el-input
                                v-model="dataDetail.txtManCostSum"
                                type="text"
                                size="mini"
                                :disabled="true"
                        ></el-input>
                    </td>
                </tr>
                <tr>
                    <td>{{ $t("getapi[1975]") }}</td>
                    <td>
                        <el-select
                                filterable
                                v-model="dataDetail.cbomonth"
                                size="mini"
                                style="margin-righ:20px"
                                @change="getMonthData()"
                        >
                            <el-option
                                    v-for="item in monthList"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value"
                            ></el-option>
                        </el-select>
                    </td>
                    <td>{{ $t("getapi[7626]") }}</td>
                    <td>
                        <el-input
                                v-model="dataDetail.txtEndCost"
                                type="text"
                                size="mini"
                                :disabled="true"
                        ></el-input>
                    </td>
                    <td style="width:60px">{{ $t("getapi[7627]") }}</td>
                    <td style="width:150px;">
                        <el-input
                                v-model="dataDetail.txtChargeCostSum"
                                type="text"
                                size="mini"
                                :disabled="true"
                        ></el-input>
                    </td>
                    <td style="width:300px">
                        <el-radio disabled v-model="dataDetail.assign" label="0"
                        >{{ $t("getapi[7628]") }}
                        </el-radio
                        >
                        <el-radio disabled v-model="dataDetail.assign" label="1"
                        >{{ $t("getapi[7629]") }}
                        </el-radio
                        >
                        <el-radio disabled v-model="dataDetail.assign" label="2"
                        >{{ $t("getapi[7630]") }}
                        </el-radio
                        >
                    </td>
                </tr>
            </table>
            <div id="xpane-0">
                <vxe-table
                        :data="datajson.Lists"
                        size="mini"
                        :loading="loading"
                        header-cell-class-name="headerclass"
                        ref="VXTable"
                        :height="tableHeight - 130"
                        @row-click="selectrow"
                        :highlight-current-row="true"
                        stripe
                        border
                        resizable
                >
                    <vxe-table-column type="checkbox" align="center" width="30"></vxe-table-column>
                    <vxe-table-column
                            show-footer-overflow
                            v-for="item in datajson.TbHeader"
                            :key="item.Headen"
                            :field="item.Headen"
                            :title="item.Headcn"
                            :align="item.Headen =='std_manhour' || item.Headen =='actually_manhour' ||
                    item.Headen == 'man_cost' || item.Headen =='charge_cost'?'right':'left'"
                            width="120px"
                    >
                        <template scope="scope" >
                            <span v-if="item.Headen =='std_manhour' || item.Headen =='actually_manhour' ||
                            item.Headen =='man_cost' || item.Headen =='charge_cost'">{{ scope.row[item.Headen] | thousandth}}</span>
                            <span v-else>{{ scope.row[item.Headen]}}</span>
                        </template>
                    </vxe-table-column>
                </vxe-table>
            </div>
        </div>

        <el-dialog
                v-dialogDrag
                :visible.sync="isShowSelectSheet"
                width="25%"
                :close-on-click-modal="false"
        >
            <el-table
                    :data="dataSelectSheet"
                    ref="sheetTable"
                    :highlight-current-row="true"
                    show-overflow-tooltip="true"
                    border
                    size="mini"
                    @row-click="changeItem_code"
                    @selection-change="handleSelectionChange"
                    header-row-class-name="headerclass"
                    style="width: 100%; margin-top:0px"
            >
                <el-table-column type="selection"></el-table-column>
                <el-table-column
                        show-overflow-tooltip
                        prop="name"
                        label="Sheet名"
                ></el-table-column>
            </el-table>

            <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="isShowSelectSheet = false">{{
          $t("getapi[2054]")
        }}</el-button>
        <el-button
                size="mini"
                type="primary"
                @click="getNoBalanceData"
                :disabled="selectNameData.length != 1"
        >{{ $t("getapi[1146]") }}</el-button
        >
      </span>
        </el-dialog>
    </div>
</template>

<script>
    import Common from "@/components/Common";
    import Array from "@/components/Array";

    export default {
        name: "3_monthworkexport",
        computed: {
            tableHeight(){
                return this.$windowSize.tableHeight-150
            }
        },
        data() {
            return {
                userData: [], // 用户信息
                DbTbNames: "",
                loading: false, // 主表加载状态
                dataDetail: {
                    cboyear: "",
                    cbomonth: "",
                    assign: "",
                    txtManCostSum: "",
                    txtChargeCostSum: "",
                    txtSettleStatus: "", //月结状态
                    txtEndCost: "", //标定状态
                    IsMonthBalance: "",
                    costEndFlag: "",
                    sum: "",
                },
                monthList: [
                    {
                        value: 1,
                        label: 1,
                    },
                    {
                        value: 2,
                        label: 2,
                    },
                    {
                        value: 3,
                        label: 3,
                    },
                    {
                        value: 4,
                        label: 4,
                    },
                    {
                        value: 5,
                        label: 5,
                    },
                    {
                        value: 6,
                        label: 6,
                    },
                    {
                        value: 7,
                        label: 7,
                    },
                    {
                        value: 8,
                        label: 8,
                    },
                    {
                        value: 9,
                        label: 9,
                    },
                    {
                        value: 10,
                        label: 10,
                    },
                    {
                        value: 11,
                        label: 11,
                    },
                    {
                        value: 12,
                        label: 12,
                    },
                ],
                yearList: [],
                uploadurl: "",
                datajson: [],
                returnArray: [],
                returnURL: "",
                excelURL: "",
                fileList: [],
                isShowSelectSheet: false, // 是否显示选择sheet弹窗
                dataSelectSheet: [], //
                selectNameData: [], // 选择的sheet
                selectIndex: "", //选中行下标
                btn: {
                    canDoCloseWIP: false,
                    doVerify: false,
                },
                scrollTop: 0,
            };
        },
        beforeMount() {
            let that = this;
            that.userData = sessionStorage.getItem("userData");
            let token = JSON.parse(that.userData).token;
            that.uploadurl =
                Common.Url + "/Fin/Wip/BalanceLockImportUpFile?token=" + token;
        },
        watch: {
            'datajson.Lists': function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(0)
                })
            },
        },
        mounted: function () {
            let that = this;
            that.userData = sessionStorage.getItem("userData");
            //that.dataDetail.cboyear = new Date().getFullYear();
            let thisyear = new Date().getFullYear();
            for (let i = 0; i < 5; i++) {
                let obj = {
                    value: thisyear - i,
                    label: thisyear - i,
                };
                that.yearList.push(obj);
            }
            that.dataDetail.cboyear = thisyear;
            that.getAssign();
            that.authority();
        },
        activated() {
            let that = this
            setTimeout(() => {
                that.$refs.VXTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                }, false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(() => {
                setTimeout(() => {
                    this.$refs.VXTable.bodyWrapper.scrollTop = this.scrollTop;
                }, 13)
            })
        },
        methods: {
            help() {
                this.$refs.SetBtn.showHelp(this.$options.name, this.$t("getapi[6634]"), this.$t("getapi[6633]"));
            },
            //type 1 一览权限 、2 编辑界面权限
            authority() {
                let that = this;
                if (that.$loadviewfields.isEnableHelp(this.$options.name) == 1) {
                    that.$refs.SetBtn.SetOneBtnEnable('help', true);
                }
                that.$refs.SetBtn.SetButtonEnable("");
                that.btn.doVerify = false;
                // console.log("权限:"+that.$limits.authority('plv3', 471, 1))
                if (that.$limits.authority("plv2", 471, 1) > 0) {
                    that.btn.doVerify = true;
                }
            },
            getAssign() {
                let that = this;
                that.$http.urlpost("/CostCalc/MMCView/GetmanChargeAssign", {}, function (
                    res
                ) {
                    if (res.Success == 1) {
                        that.dataDetail.assign = res.Key;
                        that.authority();
                    }
                });
            },
            getMonthData() {
                let that = this;
                let param = {
                    TYear: that.dataDetail.cboyear,
                    Month: that.dataDetail.cbomonth,
                };
                that.loading = true;
                that.$http.urlpost(
                    "/CostCalc/MMCView/GetCboMonthSelectedView",
                    param,
                    function (res) {
                        if (res.Success == 1) {
                            //  {
                            //   "txtManCostSum": "string",
                            //   "txtChargeCostSum": "string",
                            //   "IsMonthBalance": "string",
                            //   "GetCostEndFlag": "string",
                            //   "txtSettleStatus": "string",
                            //   "costEndFlag": 0,
                            //   "Success": 0,
                            //   "Msg": "string",
                            //   "DataContent": {}
                            // }
                            that.datajson.TbHeader = res.DataContent.TbHeader;
                            that.datajson.Lists = res.DataContent.Lists;
                            that.dataDetail.txtManCostSum = res.txtManCostSum;
                            that.dataDetail.txtChargeCostSum = res.txtChargeCostSum;
                            that.dataDetail.txtSettleStatus = res.txtSettleStatus;
                            that.dataDetail.IsMonthBalance = res.IsMonthBalance;
                            if (res.costEndFlag == 1) that.dataDetail.txtEndCost = "YES";
                            else that.dataDetail.txtEndCost = "NO";
                        }
                        that.loading = false;
                        that.authority();
                    }
                );
            },
            handleRemove(file, fileList) {
                console.log(file, fileList);
            },
            handlePreview(file) {
                console.log("handlePreview" + file);
            },
            handleChange(file, fileList) {
                let that = this;
                that.loading = true;
                console.log(file);
                if (file.response) {
                    let response = file.response.Success;
                    if (response == 0) {
                        that.$message.error(file.response.Msg);
                    }
                    that.loading = false;
                }
            },
            handleSuccess(res, file, fileList) {
                let that = this;
                console.log(res);
                let response = res.Success;
                if (response == 0) {
                    that.$message.error(that.$processdata.explainCallbackMsg(res.Msg))
                } else {
                    that.returnURL = res.DataContent.URL;
                    let arr = res.DataContent.SheetList;
                    if (arr.length > 0) {
                        that.dataSelectSheet = [];
                        for (let i = 0; i < arr.length; i++) {
                            that.dataSelectSheet = [
                                ...that.dataSelectSheet,
                                {
                                    name: arr[i],
                                },
                            ];
                        }
                        that.isShowSelectSheet = true;
                    }
                }
                that.fileList = [];
                that.loading = false;
            },
            handleError(err, file, fileList) {
                let that = this;
                that.$message.error(that.$t('getapi[8585]') + ':' + err);//上传失败
                that.loading = false;
            },
            downFile() {
                let that = this;
                let data = {
                    TYear: that.dataDetail.cboyear,
                    Month: that.dataDetail.cbomonth,
                    manChargeAssign: that.dataDetail.assign,
                };
                that.$http.urlpost(
                    "/CostCalc/MMCView/GetMonthManChargeManageImportTemplat",
                    data,
                    function (res) {
                        if (res.Success == 1) {
                            let hrefurl = Common.Url + res.DataContent.URL;
                            window.open(hrefurl);
                        }
                        that.authority();
                    }
                );
            },
            getNoBalanceData() {
                let that = this;
                let parm = {
                    filepath: that.returnURL,
                    sheetname: that.selectNameData[0],
                };
                that.$http.urlpost(
                    "/CostCalc/MMCView/GetMonthManChargeManageData",
                    parm,
                    function (res) {
                        if (res.Success == 1) {
                            that.datajson = res.DataContent;
                            that.dataDetail.txtManCostSum = res.DataContent.txtManCostSum;
                            that.dataDetail.txtChargeCostSum = res.DataContent.txtChargeCostSum;
                            that.isShowSelectSheet = false;
                            that.btn.canDoCloseWIP = false;
                        }

                        that.authority();
                    }
                );
            },
            changeItem_code(row) {
                let that = this;
                that.$refs.sheetTable.toggleRowSelection(row);
            },
            // 批量选择
            handleSelectionChange(val) {
                let that = this;
                console.log(val);
                that.selectNameData = [];
                for (let i = 0; i < val.length; i++) {
                    that.selectNameData.push(val[i].name);
                }
            },
            // 执行检验
            doVerify() {
                let that = this;
                that.loading = true;
                let parm = {
                    cboyear: that.dataDetail.cboyear,
                    cbomonth: that.dataDetail.cbomonth,
                    filepath: that.datajson.URL,
                    Lists: that.datajson.Lists,
                };
                that.$http.urlpost(
                    "/CostCalc/MMCView/GetNoBalanceLockRoutDataVerify",
                    parm,
                    function (res) {
                        if (res.Success == 1) {
                            that.datajson = res.DataContent;
                            that.btn.canDoCloseWIP = true;
                            that.loading = false;
                        } else if (res.Success == 2) {
                            that.$message.warning(that.$processdata.explainCallbackMsg(res.Msg))
                            that.datajson = res.DataContent;
                            that.loading = false;
                        } else {
                            that.loading = false;
                        }
                        that.authority();
                    }
                );
            },
            PostCaculate(param) {
                let that = this;
                that.$http.urlpost(
                    "/CostCalc/MMCView/MonthManChargeManageImportSave",
                    param,
                    function (res) {
                        if (res.Success == 1) {
                            that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                            that.dataDetail.sum = res.UniqueNum;
                        } else if (res.Success == 2 || res.Success == 3) {
                            //提示与返回
                            that
                                .$confirm(that.$processdata.explainCallbackMsg(res.Msg), that.$t('getapi[194]'), {
                                    confirmButtonText: that.$t('getapi[1146]'),
                                    cancelButtonText: that.$t('getapi[2054]'),
                                    type: "warning",
                                })
                                .then(() => {
                                    param.confirmflag = res.Success;
                                    that.PostCaculate(param);
                                })
                                .catch(() => {
                                    this.$message({
                                        type: "info",
                                        message: that.$t('getapi[6096]'),
                                    });
                                });
                        }
                        that.loading = false;
                    }
                );
            },
            // 执行标定
            doCloseWIP() {
                let that = this;
                let parm = {
                    cboyear: that.dataDetail.cboyear,
                    cbomonth: that.dataDetail.cbomonth,
                    filepath: that.datajson.URL,
                    Lists: that.datajson.Lists,
                    confirmflag: 0,
                    manchargesign: that.dataDetail.assign,
                };
                that.loading = true;
                that.PostCaculate(parm);
            },
            exps() {
                let that = this;
                that.loading = true;
                let param = {
                    TYear: that.dataDetail.cboyear,
                    Month: that.dataDetail.cbomonth,
                };
                that.$http.urlpost(
                    "/CostCalc/MMCView/GetCboMonthSelectedViewToExecl",
                    param,
                    function (res) {
                        if (res.Success == 1) {
                            let hrefurl = Common.Url + res.DataContent.URL;
                            window.open(hrefurl);
                        }
                        that.loading = false;
                    }
                );
            },

            selectrow(row) {
                let that = this;
                that.selectIndex = row.index;
            },
            removeT() {
                //let that = this
                //that.datajson.Lists.splice(that.selectIndex,1)
                let that = this;
                let selectRecords = this.$refs.VXTable.getCheckboxRecords();
                for (let i = selectRecords.length - 1; i >= 0; i--) {
                    let line = this.$refs.VXTable.getRowIndex(selectRecords[i]);
                    that.datajson.Lists.splice(line, 1);
                }
            },
            clearT() {
                let that = this;
                that.datajson.Lists = [];
            },
        },
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }
</style>
